import { uniq } from 'lodash';

import { formatValueToInputString, parseInputString } from '../ItemsListTextareaEditor/itemsListTextareaEditor';

export const formatDisabledIpsEditorValue = (items: string[]): string => {
    return formatValueToInputString(items, '\n');
};

export const parseDisabledIpsEditorValue = (inputValue: string): string[] => {
    return uniq(parseInputString(inputValue, '[\\s,]').filter(value => value.trim() !== ''));
};
